// extracted by mini-css-extract-plugin
module.exports = {"header__message-creator":"message-creator_header__message-creator__3ch1r"};